import script from "./AboutUsDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUsDoc.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUsDoc.vue?vue&type=style&index=0&id=2b010378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b010378"]])

export default __exports__